import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
export class SiteViewModel extends BaseViewModel {
  getClientId = () => {
    return this.codeTag;
  };
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getSites = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var siteResponse = await this.getSiteListByClientId(this.codeTag);
    if (
      Format.isNotNull(siteResponse.errorCode) &&
      siteResponse.errorCode === 0
    ) {
      if (Format.isNotNull(siteResponse.siteList)) {
        siteResponse.siteList.forEach(async element => {
          element.buildingList = await this.getBuildings(element.id);
        });

        this.updateState("siteList", siteResponse.siteList);
        this.logger.info(siteResponse.siteList);
      } else {
        this.showEmpty("Site");
      }
    } else {
      this.showError("Site", CrudlStatus.LIST);
    }
  };
  getBuildings = async id => {
    var buildingResponse = await this.getBuildingListBySiteId(id);
    if (Format.isNotNull(buildingResponse.buildingList)) {
      buildingResponse.buildingList.forEach(async element => {
        element.crudlStatus = CrudlStatus.UPDATE;
        element.locationList = await this.getLocations(element.id);
      });
      return buildingResponse.buildingList;
    } else {
      return [];
    }
  };

  getLocations = async id => {
    var locationResponse = await this.getLocationListByBuildingId(id);
    if (Format.isNotNull(locationResponse.locationList)) {
      locationResponse.locationList.forEach(element => {
        element.crudlStatus = CrudlStatus.UPDATE;
      });
      return locationResponse.locationList;
    } else {
      return [];
    }
  };
  getSitesReturned = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var siteResponse = await this.getSiteListByCodeTag();
    if (
      Format.isNotNull(siteResponse.errorCode) &&
      siteResponse.errorCode === 0
    ) {
      if (Format.isNotNull(siteResponse.siteList)) {
        siteResponse.siteList.forEach(async element => {
          element.buildingList = await this.getBuildings(element.id);
        });
        this.logger.info(siteResponse.siteList);
        return siteResponse.siteList;
      } else {
        this.showEmpty("Site");
      }
    } else {
      this.showError("Site", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (sites, apiResponse, type, externalStateValues) => {
    var updatedSiteList = [];
    if (type === CrudlStatus.CREATE) {
      updatedSiteList = this.reloadAfterCreate(
        sites,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedSiteList = this.reloadAfterUpdate(
        sites,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedSiteList = this.reloadAfterDelete(
        sites,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("siteList", updatedSiteList);
  };

  reloadAfterCreate = (siteList, apiResponse, externalStateValues) => {
    if (siteList === undefined || siteList === null) {
      siteList = [];
    }
    var siteBean = externalStateValues.siteBean;
    siteBean.id = apiResponse.id;
    siteBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    siteList.push(siteBean);

    return siteList;
  };

  reloadAfterUpdate = (siteList, apiResponse, externalStateValues) => {
    var i = 0;
    siteList.forEach(e => {
      if (apiResponse.id === e.id) {
        siteList[i] = externalStateValues.siteBean;
        siteList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return siteList;
  };

  reloadAfterDelete = (siteList, apiResponse, externalStateValues) => {
    var i = 0;
    siteList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        siteList.splice(i, 1);
      }
      i++;
    });

    return siteList;
  };

  // createOrUpdateBuilding = async buildingRequest => {
  //   if (buildingRequest.crudlStatus === CrudlStatus.CREATE) {
  //     return await this.createBuilding(buildingRequest);
  //   } else {
  //     return await this.updateBuilding(buildingRequest);
  //   }
  // };
  // createBuilding = async buildingRequest => {
  //   buildingRequest.codeTag = this.codeTag;
  //   buildingRequest.userId = this.userId;
  //   buildingRequest.clientId = this.getClientId();

  //   let buildingResponse = await ApiService.buildingCreate(buildingRequest);
  //   if (buildingResponse.errorCode === 0) {
  //     return buildingResponse;
  //   } else {
  //     return buildingResponse;
  //   }
  // };
  // updateBuilding = async buildingRequest => {
  //   buildingRequest.codeTag = this.codeTag;
  //   buildingRequest.userId = this.userId;
  //   buildingRequest.clientId = this.getClientId();

  //   let buildingResponse = await ApiService.buildingUpdate(buildingRequest);
  //   if (buildingResponse.errorCode === 0) {
  //     return buildingResponse;
  //   } else {
  //     return buildingResponse;
  //   }
  // };
  // deleteBuilding = async buildingRequest => {
  //   buildingRequest.codeTag = this.codeTag;
  //   buildingRequest.userId = this.userId;
  //   buildingRequest.clientId = this.getClientId();

  //   let buildingResponse = await ApiService.buildingDelete(buildingRequest);
  //   if (buildingResponse.errorCode === 0) {
  //     return buildingResponse;
  //   } else {
  //     return buildingResponse;
  //   }
  // };
  // createOrUpdateLocation = async buildingRequest => {
  //   if (buildingRequest.crudlStatus === CrudlStatus.CREATE) {
  //     return await this.createLocation(buildingRequest);
  //   } else {
  //     return await this.updateLocation(buildingRequest);
  //   }
  // };
  // createLocation = async locationRequest => {
  //   locationRequest.codeTag = this.codeTag;
  //   locationRequest.userId = this.userId;
  //   locationRequest.clientId = this.getClientId();

  //   let locationResponse = await ApiService.locationCreate(locationRequest);
  //   if (locationResponse.errorCode === 0) {
  //     return locationResponse;
  //   } else {
  //     return locationResponse;
  //   }
  // };
  // updateLocation = async locationRequest => {
  //   locationRequest.codeTag = this.codeTag;
  //   locationRequest.userId = this.userId;
  //   locationRequest.clientId = this.getClientId();

  //   let locationResponse = await ApiService.locationUpdate(locationRequest);
  //   if (locationResponse.errorCode === 0) {
  //     return locationResponse;
  //   } else {
  //     return locationResponse;
  //   }
  // };
  // deleteLocation = async locationRequest => {
  //   locationRequest.codeTag = this.codeTag;
  //   locationRequest.userId = this.userId;
  //   locationRequest.clientId = this.getClientId();

  //   let locationResponse = await ApiService.locationDelete(locationRequest);
  //   if (locationResponse.errorCode === 0) {
  //     return locationResponse;
  //   } else {
  //     return locationResponse;
  //   }
  // };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let siteRequest = stateVariables.siteBean;

    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createSite(siteRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateSite(siteRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteSite(siteRequest);
    }
  };

  createSite = async (siteRequest, stateVariables) => {
    siteRequest.codeTag = this.codeTag;
    siteRequest.userId = this.userId;
    siteRequest.clientId = this.getClientId();

    let siteResponse = await ApiService.siteCreate(siteRequest);
    if (siteResponse.errorCode === 0) {
      // siteRequest.buildingRequestList.forEach(async element => {
      //   element.siteId = siteResponse.id;
      //   if (Format.isNotNull(element.crudlStatus)) {
      //     var buildingResponse = await this.createBuilding(element);

      //     element.locationRequestList.forEach(async element => {
      //       element.buildingId = buildingResponse.id;

      //       await this.createLocation(element);
      //     });
      //   }
      // });

      this.showSuccess("Site", CrudlStatus.CREATE);
    } else {
      this.showError("Site", CrudlStatus.CREATE);
    }

    return siteResponse;
  };

  deleteSite = async siteRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = siteRequest.id;
    request.lastUpdatedDateTime = siteRequest.lastUpdatedDateTime;

    let siteResponse = await ApiService.siteDelete(request);
    if (siteResponse.errorCode === 0) {
      this.showSuccess("Site", CrudlStatus.DELETE);
    } else {
      this.showError("Site", CrudlStatus.DELETE);
    }

    return siteResponse;
  };

  updateSite = async (siteRequest, stateVariables) => {
    siteRequest.codeTag = this.codeTag;
    siteRequest.userId = this.userId;
    siteRequest.clientId = this.getClientId();

    let siteResponse = await ApiService.siteUpdate(siteRequest);
    if (siteResponse.errorCode === 0) {
      // siteRequest.buildingRequestList.forEach(async building => {
      //   building.siteId = siteResponse.id;
      //   console.log(building);
      //   if (Format.isNotNull(building.crudlStatus)) {
      //     var buildingResponse = await this.createOrUpdateBuilding(building);

      //     console.log(buildingResponse);
      //     building.locationRequestList.forEach(async location => {
      //       location.buildingId = buildingResponse.id;
      //       this.createOrUpdateLocation(location);
      //     });
      //   }
      // });
      // if (Format.isNotNull(stateVariables.deletedBuildingList)) {
      //   stateVariables.deletedBuildingList.forEach(async element => {
      //     await this.deleteBuilding(element);
      //   });
      // }
      // if (Format.isNotNull(stateVariables.deletedLocationList)) {
      //   stateVariables.deletedLocationList.forEach(async element => {
      //     await this.deleteLocation(element);
      //   });
      // }
      this.showSuccess("Site", CrudlStatus.UPDATE);
    } else {
      this.showError("Site", CrudlStatus.UPDATE);
    }

    return siteResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/Sites/SiteViewModel.js